import { useEffect } from 'react';
import { useLocation } from '@remix-run/react';
import { sendEventToGA, sendEventToHeap } from '@/utils/analytics/analytics';

const SCROLL_PERCENT_INCREMENT = 20;

export const useScrollDepthTracker = (): void => {
  const location = useLocation();

  useEffect(() => {
    const trackedDepths = new Set<number>();

    const handleScroll = () => {
      const scrollHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const scrollDistance = window.scrollY || 0;
      const scrollPercent = Math.floor((scrollDistance / scrollHeight) * 100);

      for (
        let depth = SCROLL_PERCENT_INCREMENT;
        depth <= 100;
        depth += SCROLL_PERCENT_INCREMENT
      ) {
        if (scrollPercent >= depth && !trackedDepths.has(depth)) {
          sendEventToGA({
            event: 'Scroll Depth',
            percent: depth,
          });

          sendEventToHeap('Scroll Depth', {
            percent: depth,
          });

          trackedDepths.add(depth);
        }
      }
    };

    document.addEventListener('scroll', handleScroll);

    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, [location.pathname]);
};
